export default __webpack_public_path__ + "static/sig_compare_comp2_inactive-e04045a359acb950649dfb8968f8633c.png";